// Generated file: Do not edit 
// generated from @taqueria-protocol-types
    
import { TaqError, toFutureParseErr, toFutureParseUnknownErr, toParseErr, toParseUnknownErr } from '@taqueria/protocol/TaqError';
import { FutureInstance, resolve, reject } from 'fluture';
import { ZodError } from 'zod';
import { ConfigFileV2 } from '@taqueria/protocol/types';
import { ConfigFileV2 as ConfigFileV2Strict } from '@taqueria/protocol/out/types-strict';
import { configFileV2Schema } from '@taqueria/protocol/out/types-zod';

export type { ConfigFileV2Strict as ConfigFileV2 };

export const from = (input: unknown): ConfigFileV2Strict => {
	try {
		return configFileV2Schema.parse(input) as ConfigFileV2Strict;
	}
	catch (previous: unknown) {
		if (previous instanceof ZodError) {
			const msgs: string[] = previous.errors.reduce(
				(retval, issue) => {
					const path = issue.path.join(' → ');
					const msg = path + ': ' + issue.message;
					return [...retval, msg];
				},
				["ConfigFileV2 is invalid:"],
			);
			const validationErr = msgs.join('\n') + '\n';
			throw toParseErr(previous, validationErr);
		}
		throw toParseUnknownErr(previous, "There was a problem trying to parse a ConfigFileV2.")
	}
    
};

export const create = (input: ConfigFileV2): ConfigFileV2Strict => from(input);

export const of = (input: unknown): FutureInstance<TaqError, ConfigFileV2Strict> => {
	try {
		return resolve(from(input))
	}
	catch (err){
		return reject(err) as FutureInstance<TaqError, never>
	}
};

export const make = (input: Omit<ConfigFileV2Strict, '__type'>): FutureInstance<TaqError, ConfigFileV2Strict> => of(input);

// TEMP: for interoperation with old protocol types during transition
export const schemas = {
	rawSchema: configFileV2Schema,
	schema: configFileV2Schema.transform(val => val as ConfigFileV2Strict),
};
export const rawSchema = schemas.rawSchema;
export const internalSchema = configFileV2Schema;

export type t = ConfigFileV2Strict;
        